/**
 * Бегунок автоповтора очереди неотправленного (аудит 2026-10-17, UX-48). Отдельно от хранилища
 * (`chatOutbox.ts`): он стоит над навигатором и входит в основной веб-бандл, а хранилище и
 * повтор грузятся лениво.
 */

/**
 * Когда повторять: на каждом подъёме сокета (false → true), в том числе на первом после
 * запуска — провайдер начинает с «не подключён». Пока идёт один повтор, второй не начинается.
 */
export function createOutboxReconnectRunner(run: () => Promise<unknown>): { update: (connected: boolean) => void } {
  let connected = false;
  let running = false;
  let again = false;
  const start = () => {
    if (running) {
      again = true;
      return;
    }
    running = true;
    void run()
      .catch(() => {})
      .finally(() => {
        running = false;
        if (again && connected) {
          again = false;
          start();
        }
        again = false;
      });
  };
  return {
    update: (next) => {
      const was = connected;
      connected = next;
      if (next && !was) start();
    },
  };
}
